class ThirdsApi {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                break;
        }
    }

    //Listar Patrocniadores y terceros Normales
    async listThirdsIndicators() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar-terceros-indicadores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

}

export default new ThirdsApi();